import styled from 'styled-components';
import { FaFileCsv } from 'react-icons/fa';
import theme from '../../../theme';

export const Button = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  &:focus {
    outline: none;
  }
`;

export const CsvFileIcon = styled(FaFileCsv)`
  color: ${theme.colors.gray} !important;
`;
